import { __assign } from "tslib";
import { useEffect } from 'react';
import { usePress } from '../../interactions/press';
export function useCalendarCell(props, state, ref) {
    var value = props.value, viewDate = props.viewDate;
    var isCalendarFocused = state.isCalendarFocused, activeView = state.activeView, getCellState = state.getCellState, focusDate = state.focusDate, selectDate = state.selectDate;
    var cellState = getCellState(value, viewDate);
    var isSelected = cellState.isSelected, isDisabled = cellState.isDisabled, isFocused = cellState.isFocused, isSameView = cellState.isSameView, isToday = cellState.isToday;
    var shouldBeFocused = isCalendarFocused && isFocused;
    var highlightDate = state.mode === 'range' ? state.highlightDate : null;
    var pressProps = usePress({
        disabled: isDisabled,
        onPress: function () {
            selectDate(value);
        },
    }).pressProps;
    useEffect(function () {
        if (shouldBeFocused && ref.current) {
            ref.current.focus();
        }
    }, [shouldBeFocused, ref]);
    var onMouseEnter = function () {
        highlightDate === null || highlightDate === void 0 ? void 0 : highlightDate(value);
    };
    var onFocus = function () {
        if (isSameView && !isFocused) {
            focusDate(value);
        }
    };
    var cellProps = {
        role: 'gridcell',
    };
    var buttonProps = __assign(__assign({}, pressProps), { role: 'button', 'aria-selected': isSelected, 'aria-disabled': isDisabled, 'aria-hidden': !isSameView, 
        // TODO: Set label for every view
        'aria-label': undefined });
    if (!isDisabled) {
        buttonProps.tabIndex = isSameView && isFocused ? 0 : -1;
        buttonProps.onFocus = onFocus;
    }
    if (state.mode === 'range' && !isDisabled) {
        buttonProps.onMouseEnter = onMouseEnter;
    }
    if (isToday && activeView === 'day') {
        // NOTE: Usage only for day view
        buttonProps['aria-current'] = 'date';
    }
    return {
        cellState: cellState,
        cellProps: cellProps,
        buttonProps: buttonProps,
    };
}
